import { Component, OnInit, AfterViewInit } from "@angular/core";
import { EventService } from "../core/services/event.service";
import { MessagingService } from "../core/services/messaging.service";
import { LAYOUT_VERTICAL, LAYOUT_HORIZONTAL } from "./layouts.model";
import { AuthenticationService } from "../core/services/auth.service";
import { Router } from "@angular/router";
import { TranslateService } from '@ngx-translate/core';


@Component({
	selector: "app-layout",
	templateUrl: "./layout.component.html",
	styleUrls: ["./layout.component.scss"],
})
export class LayoutComponent implements OnInit, AfterViewInit {
	// layout related config
	layoutType: string;
	message: any;
	user: any;
	constructor(
		private eventService: EventService,
		private messagingService: MessagingService,
		private authService: AuthenticationService,
		private route: Router,
		public translate: TranslateService
	) {
		translate.addLangs(['IND', 'ENG']);
    	translate.setDefaultLang('IND');
	}

	ngOnInit() {
		// default settings
		this.user = this.authService.getDetailUser();
		if (this.user.tipe == "super admin") {
			this.layoutType = LAYOUT_VERTICAL;
		} else {
			this.layoutType = LAYOUT_HORIZONTAL;
		}

		if(this.user !== null && Object.prototype.hasOwnProperty.call(this.user, 'client')){
			if(this.user.tipe == 'super admin'){
				if(this.route.url == '/backoffice' || this.route.url == '/backoffice/dashboard' || this.route.url == '/backoffice/fitur' || this.route.url == '/backoffice/paket' || this.route.url == '/backoffice/klien/3' || this.route.url == '/backoffice/pengaturan' || this.route.url == '/backoffice/invoice' || this.route.url == '/backoffice/voucher'){
					// do nothing
				}else{
					this.route.navigate(['/backoffice/dashboard']);
				}
			}else{
				if(this.route.url == '/backoffice' || this.route.url == '/backoffice/dashboard' || this.route.url == '/backoffice/fitur' || this.route.url == '/backoffice/paket' || this.route.url == '/backoffice/klien/3' || this.route.url == '/backoffice/pengaturan' || this.route.url == '/backoffice/invoice' || this.route.url == '/backoffice/voucher'){
					this.route.navigate(['/home']);
				}else{
					// do nothing
				}
			}
		}

		// listen to event and change the layout, theme, etc
		this.eventService.subscribe("changeLayout", (layout) => {
			this.layoutType = layout;
		});

		this.messagingService.requestPermission();
		this.messagingService.receiveMessage();
		this.message = this.messagingService.currentMessage;

		this.translate.setDefaultLang(this.user.bahasa);
		this.translate.use(this.user.bahasa);
	}

	ngAfterViewInit() {}

	/**
	 * Check if the vertical layout is requested
	 */
	isVerticalLayoutRequested() {
		return this.layoutType === LAYOUT_VERTICAL;
	}

	/**
	 * Check if the horizontal layout is requested
	 */
	isHorizontalLayoutRequested() {
		return this.layoutType === LAYOUT_HORIZONTAL;
	}

	switchLang(lang: string) {
	  this.translate.use(lang);
	}
}
